
import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Popover from '@material-ui/core/Popover';
import styled from 'styled-components';

import Chip from '@material-ui/core/Chip';
import { grey } from '@material-ui/core/colors';

import TableListSort from 'core/TableListSort';


const MoreButton = styled.span`
  color: #2F80ED;
  margin-left: 5px;
  
  &:hover {
    cursor: pointer;
  }
`;

const StyledTable = styled(Table)`
  td {
    vertical-align: top;
  }
`;

const MoreCounterparties =  (props) => {
  const { counterparties } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      {counterparties.length > 1 && (
        <React.Fragment>
          <MoreButton onClick={handlePopoverOpen}>еще {counterparties.length - 1}</MoreButton>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <StyledTable>
              <TableBody>
                {counterparties.map(counterparty =>
                  <TableRow key={counterparty.id}>
                    <TableCell>
                      {counterparty.name}<br/>
                      {counterparty.inn && (<span>ИНН {counterparty.inn}</span>)}
                    </TableCell>
                    <TableCell>
                      {counterparty.contacts.map(contact =>
                        <div className={'mb-5'} key={contact.id}>
                          <span>{contact.name}</span><br />
                          {contact.phone && <span>{contact.phone}</span>}
                          {contact.emails.length > 0 && (
                            <a href={`mailto:${contact.emails[0]}`}>{contact.emails[0]}</a>
                          )}
                        </div>
                      )}
                    </TableCell>
                    <TableCell>
                      {counterparty.tariff && counterparty.tariff.name}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </StyledTable>
          </Popover>
        </React.Fragment>
      )}
    </React.Fragment>
  )
};


const FirstCounterpartyContact = (props) => {
  const { counterparties } = props;

  let contact = undefined;
  if (counterparties && counterparties.length > 0 && counterparties[0].contacts.length > 0) {
    contact = counterparties[0].contacts[0];
  }
  return (
      <React.Fragment>
        {contact && (
          <React.Fragment>
            <span>{contact.name}</span><br />
            {contact.phone && <span>{contact.phone}</span>}
            {contact.email && <span>, <a href={`mailto:${contact.email}`}>{contact.email}</a></span>}
          </React.Fragment>
        )}
      </React.Fragment>
  )
};


const FirstCounterpartyTariff = (props) => {
  const { counterparties } = props;
  let tariff = undefined;
  if (counterparties && counterparties.length > 0) {
    tariff = counterparties[0].tariff;
  }
  return (
    <React.Fragment>
      {tariff && (tariff.name)}
    </React.Fragment>
  )
};


const CounterpartyDisplay = (props) => {
  const { counterparties } = props;

  let counterparty = undefined;
  if (counterparties.length > 0) {
    counterparty = counterparties[0];
  }

  return (
    <React.Fragment>
      {counterparty && (
        <React.Fragment>
          {counterparty.name}<br/>
          {counterparty.inn && (<span>ИНН {counterparty.inn}</span>)}
        </React.Fragment>
      )}
      <MoreCounterparties counterparties={counterparties} />
    </React.Fragment>
  )
};


export class ClientListTable extends Component {
  render() {
    const { items, onDetail } = this.props;

    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row" className={'hide-on-mobile'}>
              <TableListSort label={'#'} name={'id'} />
            </TableCell>
            <TableCell component="th" scope="row">Клиент</TableCell>
            <TableCell component="th" scope="row">Контрагенты</TableCell>
            <TableCell component="th" scope="row">Контактные лица</TableCell>
            <TableCell component="th" scope="row">Тариф</TableCell>
            <TableCell component="th" scope="row">Менеджер</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {items.map(client =>
          <TableRow
            key={client.id}
            hover={true}
            style={{
              backgroundColor: client.is_active ? 'inherit' : grey[200]
            }}
          >
            <TableCell className={'pointer hide-on-mobile'} onClick={() => onDetail(client)}>{client.id}</TableCell>
            <TableCell className={'pointer'} onClick={() => onDetail(client)}>
              {client.name}
              {!client.is_active && (
                <div className={'mt-5'}>
                  <Chip label={'Неактивен'} size={'small'} />
                </div>
              )}
            </TableCell>
            <TableCell>
              <CounterpartyDisplay counterparties={client.counterparties} />
            </TableCell>
            <TableCell>
              <FirstCounterpartyContact counterparties={client.counterparties} />
            </TableCell>
            <TableCell>
              <FirstCounterpartyTariff counterparties={client.counterparties} />
            </TableCell>
            <TableCell>
              {client.personal_manager && (
                (client.personal_manager.short_name)
              )}
            </TableCell>
          </TableRow>
        )}
        </TableBody>
      </React.Fragment>
    )
  }
}
